import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import toast from 'shared/utils/toast';
import { ICreateAccessorPayload } from '../types';
import { getApiErrorMessage } from '../utils';
import { accessorService } from '../api/accessor.service.ts';

export const useCreateAccessor = () => {
  const translationPrefix = 'pages.accessories';
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onSubmit = async (values: ICreateAccessorPayload) => {
    try {
      await accessorService.create(values);
      toast.success(t(`${translationPrefix}.success`));
      navigate('../');
    } catch (error) {
      toast.error(getApiErrorMessage(error, t('pages.accessories.error-generic')));
    }
  };

  return { onSubmit };
};
